module.exports = __webpack_public_path__ + "static/media/Isaiah McPeak Headshot_1626464479690.7e8b269c.jpeg";